/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  TenantGuaranteeFundHistoryOptions,
  TenantGuaranteeFundHistoryResponses,
} from '../types/TenantGuaranteeFundHistory'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary List guarantee fund ledger rows and totals by transaction kind for a tenant.
 * {@link /v1/tenants/:tenant_id/guarantee_fund}
 */
export function tenantGuaranteeFundHistory<ThrowOnError extends boolean = true>(
  options: Options<TenantGuaranteeFundHistoryOptions, ThrowOnError>,
): Unwrappable<RequestResult<TenantGuaranteeFundHistoryResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/tenants/{tenant_id}/guarantee_fund',
      security: [{ type: 'http', scheme: 'bearer' }],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<TenantGuaranteeFundHistoryResponses, ThrowOnError>>,
  )
}
